import React from "react";

import { Card, Grid, Button } from "@mui/material";

import CardBody from "components/Card/CardBody.js";

export function NeedEmailVerification(props) {
  const { resentEmail, resend } = props;
  return (
    <Grid container>
      <Grid item md={2} />
      <Grid item md={8}>
        <Card>
          <CardBody>
            <h1>This function requires email verification</h1>
            <p>
              When you signed up for this Developer Portal, you should have
              received an email asking you to verify your email address. It
              appears that you have not yet done so. Check your inbox and your
              junk mailbox for the message, and follow the instructions there.
            </p>
            <p>
              If you&apos;d like us to send another verification email, click
              the button below.
            </p>
            <Button onClick={() => resend()}>Re-send verification email</Button>
            {resentEmail !== "" && (
              <span
                id="sent-email-notice"
                style={{
                  fontVariant: "small-caps",
                  marginLeft: "1.0em",
                  color: "#056dae",
                  fontWeight: "400",
                }}
              >
                {resentEmail}
              </span>
            )}
          </CardBody>
        </Card>
      </Grid>
      <Grid item md={2} />
    </Grid>
  );
}
